import { render, staticRenderFns } from "./SpeedReading.vue?vue&type=template&id=506799cc&scoped=true&"
import script from "./SpeedReading.vue?vue&type=script&lang=js&"
export * from "./SpeedReading.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"
import style1 from "./SpeedReading.vue?vue&type=style&index=1&id=506799cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506799cc",
  null
  
)

export default component.exports